import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { LoteCabotajeService } from 'src/app/_services/loteCabotaje/lote-cabotaje.service';
import { ScaleTicketService } from 'src/app/_services/scale-ticket/scale-ticket.service';
import { TonsPerYardService } from 'src/app/_services/tons-per-yard/tons-per-yard.service';
import { BlDetails, ExportBoats, TableConfig } from 'src/app/interfaces/bl.interfaces';
import { CabotageBatch } from 'src/app/interfaces/cabotageBatches.interfaces';
import { ExportOutput, ExportOutputType } from 'src/app/interfaces/exportationBatches.interfaces';
import { LocationInterface, SalidaCatalogo, TranportLine, Transport } from 'src/app/interfaces/lotes.interfaces';
import { GenericTicket, Module, OperationType, OriginTicket } from 'src/app/interfaces/scale-ticket.interfaces';
import { TonsPerYard } from 'src/app/interfaces/tons-per-yard.interfaces';
import { AmountsByInputLocationsComponent } from 'src/app/shared/components/amounts-by-input-locations/amounts-by-input-locations.component';
import { getDate } from 'src/app/shared/utils';

enum ScannerType {
  Scanner = 'scanner',
  Camera = 'camera',
  Close = 'close',
}

/**
 * Componente que gestiona el formulario de salida por acuerdo aduanal de un lote de cabotaje,
 * permitiendo registrar o actualizar salidas con captura de tickets de báscula, registros de
 * transporte, líneas de transporte y lectura de códigos QR.
 */
@Component({
  selector: 'app-cabotaje-form-salida-acuerdo-aduanal',
  templateUrl: './cabotaje-form-salida-acuerdo-aduanal.component.html',
  styleUrls: ['./cabotaje-form-salida-acuerdo-aduanal.component.css']
})
export class CabotajeFormSalidaAcuerdoAduanalComponent implements OnInit {
  @Input() containerStyles = {
    'grid-template-columns': 'repeat(4, 1fr)'
  };
  @Input() movimiento: string = 'crear';
  @Input() cabotageBatch: CabotageBatch[] = [];
  @Input() outputDetail: ExportOutput[] = [];
  @Input() outputTypes: ExportOutputType[] = [];
  @Output() onRegresar = new EventEmitter<boolean>();
  @Output() onTipoSalida = new EventEmitter<string>();
  outputForm: FormGroup;
  @Input() tipoTransporte: SalidaCatalogo[] = [];
  @Input() tipoUnidad: SalidaCatalogo[] = [];
  @Input() originsTicket: OriginTicket[] = [];
  @Input() archivos = {
    documento: '',
    acuerdoAduanal: '',
  };
  @Input() locations: LocationInterface[] = [];
  @Input() listTransportLine: TranportLine[] = [];
  @Input() amountsPerYardList: TonsPerYard[] = [];
  @Input() boats: ExportBoats[] = [];
  @Input() outputs: ExportOutput[] = [];
  @Input() blDetails: BlDetails = {
    operation_number:     0,
    boats_name:           '',
    operation_type_number:0,
    bl_tonnage:           0,
    customer_name:        null,
    date_time_capture:    '',
    dock_name:            '',
    port_origin_name:     '',
    start_operations:     '',
    end_operations:       '',
    boat_nationality:     '',
    destination_port:     '',
    operation_id:         0,
    docking_date:         '',
    undocking_date:       '',
    bl_master:            '',
    notice_of_readiness:  '',
  };
  table_config: TableConfig = {
    tableHeads: [
      ['Peso bruto', 'gross_weight'],
      ['Peso tara', 'tare_weight'],
      ['Peso neto', 'net_weight'],
      ['Piezas', 'quantity_pieces'],
      ['Placas', 'plate'],
      ['Folio ticket', 'no_ticket']
    ],
    tableHeadsContainer: ['Detalle', 'Editar', 'Eliminar'],
    styles: {
      table_heads: {
        'grid-template-columns': 'repeat(6, minmax(90px, 1fr)) minmax(200px, auto)',
        'min-width': '740px',
      },
      table_row: {
        'grid-template-columns': 'repeat(6, minmax(90px, 1fr)) minmax(200px, auto)',
        'min-width': '740px',
      },
      container_icons: {
        'grid-template-columns': 'repeat(3, 1fr)',
      },
      table_row_totals: {
        'grid-template-columns': 'repeat(6, minmax(90px, 1fr)) minmax(200px, auto)',
        'min-width': '740px',
        'background-color': '#455660',
        'color': '#fff',
      },
    },
    arrayFields: [
      'gross_weight',
      'tare_weight',
      'net_weight',
      'quantity_pieces',
      'plate',
      'no_ticket'
    ],
    iconos: [["/eliminar-abandono", "id", 'bi bi-eye'], ["/actualizar-abandono", "id", 'bi bi-pencil-square'], ["/eliminar-entry-export", "id", 'bi bi-trash3']],
    mensaje: "Sin registros.",
    filter: true,
    totals: {
      show: true,
      content: ['', 'Totales:', 'totalNetWeight', 'piezas', '', ''],
      total: 0,
      totalNetWeight: 0,
      piezas: 0,
    }
  };
  maxSize: boolean = false;
  mensajeError: string = 'Ingrese el archivo';
  overlay: boolean = false;
  mensajeOverlay: string = '';
  iconoOverlay: string = '';
  buttons: boolean = false;
  loading: boolean = false;
  output: ExportOutput = {
    output_type_option_id:  0,
    cabotage_batch_id:      0,
    checker_name:           '',
    precinct_key:           0,
    departure_date:         '',
    ship_number:            0,
    ship_name:              '',
    addressee:              '',
    destination_company:    '',
    request_number:         0,
    customs_agent:          '',
    withdrawal_number:      '',
    entrie_output_file:     '',
    location_list:          []
  }
  batchValue: number = 0;
  id: number = 0;

  tipoSalida: FormControl = new FormControl('6');
  loaderTicket: boolean = false;
  isValidModule: boolean = false;

  // Transport
  @Input() transportList: any[] = [];
  overlayTransport: boolean = false;
  confirmCreate: boolean = false;
  loader: boolean = false;
  transportForm: FormGroup;
  loaderRailwayGroup: boolean = false;
  updateTranpostForm: boolean = false;
  net_weight: number = 0;
  currentIdTransport: number = 0;
  idCount: number = 1;
  messageTicket: string = '';
  updateTransport: boolean = false;
  addTransport: boolean = false;
  currentTransportId: number = 0;
  transportDelete: boolean = false;
  ticketChangeCount: number = 0;

  // Transport Line
  transportLineOverlay: boolean = false;
  loaderTransportLine: boolean = false;
  transportLine: FormControl = new FormControl();
  formTransportLine: FormControl = new FormControl();
  listTransportLineFilter: TranportLine[] = [];

  // Scanner
  overlayScanner: boolean = false;
  scannerEnabled: boolean = false;
  gunScannerEnabled: boolean = true;
  isValidQR: boolean = true;
  autofocusEnabled: boolean = true;
  cameraSelected: FormControl = new FormControl();
  scannerTextArea: FormControl = new FormControl();
  selectedDevice!: MediaDeviceInfo;
  camerasList: MediaDeviceInfo[] = [];
  qrResultString: string | null = '';

  // Tons and Pieces into Patios
  entryTonnage: number = 0;
  entryPieces: number = 0;
  @ViewChild(AmountsByInputLocationsComponent) amountsComponent!: AmountsByInputLocationsComponent;

  constructor(
    private authService: AuthService,
    private loteCabotajeService: LoteCabotajeService,
    private scaleTicketSvc: ScaleTicketService,
    private localStorageSvc: LocalStorageService,
    private amountsPerYardSvc: TonsPerYardService,
    private fb: FormBuilder,
    private router: Router,
  ) {
    const fullName = this.localStorageSvc.getFullName();
    const isCheckerNameDisabled = fullName ? true : false;
    this.outputForm = this.fb.group({
      output_type_option_id: [],
      number_custom_agreement: [, [Validators.required]],
      departure_date:[getDate(), [Validators.required]],
      customs_agreement_output: [],
      customs_agreement_document: [],
      total_tonnage: [, [Validators.required, Validators.pattern(/^(?!0\d)\d{0,11}(?:\.\d{1,3})?$/)]],
      total_pieces: [],

      transport_type_id: [''],
      trailer_id: [''],
      original_scale: [''],
      railway_group: [],
      tractor_plates: [],
      checker_name: [{value: fullName, disabled: isCheckerNameDisabled}],

      operator_name: [],
      transport_line_id: [''],
      destiny: [],
      company_destiny: [],
      customs_agent: [],
    });
    this.transportForm = fb.group({
      gross_weight: [, [Validators.required, Validators.pattern(/^(?!0\d)\d{0,11}(?:\.\d{1,3})?$/)]],
      tare_weight: [, [Validators.required, Validators.pattern(/^(?!0\d)\d{0,11}(?:\.\d{1,3})?$/)]],
      quantity_pieces: [0, [Validators.required, Validators.pattern(/^[0-9]+$/)]],
      plate: [, [Validators.required]],
      no_ticket: [],
      no_slab: [],
      no_cast: [],
      no_bl: []
    });
    if (this.router.url.includes('output/'))
      this.outputForm.get('customs_agreement_document')?.addValidators([Validators.required]);
  }

  ngOnInit(): void {
    const parts = this.router.url.split("/");
    this.batchValue = Number(parts[parts.length - 1]);
    this.tipoSalida.valueChanges.subscribe( tipoSalida => {
      this.onTipoSalida.emit(tipoSalida);
    });
    if (this.movimiento === 'detalle') {
      this.table_config.tableHeadsContainer = ['Boleta', 'Detalle'];
      this.table_config.styles.container_icons['grid-template-columns'] = "repeat(2, 1fr)";
      this.table_config.styles.table_heads['grid-template-columns'] = "repeat(6, minmax(90px, 1fr)) minmax(120px, auto)";
      this.table_config.styles.table_heads['min-width'] = "660px";
      this.table_config.styles.table_row['grid-template-columns'] = "repeat(6, minmax(90px, 1fr)) minmax(120px, auto)";
      this.table_config.styles.table_row['min-width'] = "660px";
      this.table_config.styles.table_row_totals!['grid-template-columns'] = "repeat(6, minmax(90px, 1fr)) minmax(120px, auto)";
      this.table_config.styles.table_row_totals!['min-width'] = "660px";
      this.table_config.iconos = [["/detalle-export-entry", "id_cabotage_weight_list", "bi bi-download"], ["/eliminar-abandono", "id_cabotage_weight_list", 'bi bi-eye']];
    } else if (this.movimiento === 'actualizar') {
      this.table_config.tableHeadsContainer = ['Detalle', 'Editar', 'Eliminar'];
      this.table_config.styles.container_icons['grid-template-columns'] = "repeat(3, 1fr)";
      this.table_config.styles.table_heads['grid-template-columns'] = "repeat(6, minmax(90px, 1fr)) minmax(200px, auto)";
      this.table_config.styles.table_row['grid-template-columns'] = "repeat(6, minmax(90px, 1fr)) minmax(200px, auto)";
      this.table_config.styles.table_row_totals!['grid-template-columns'] = "repeat(6, minmax(90px, 1fr)) minmax(200px, auto)";
      this.table_config.iconos = [["/eliminar-abandono", "id_cabotage_weight_list", 'bi bi-eye'], ["/actualizar-abandono", "id_cabotage_weight_list", 'bi bi-pencil-square'], ["/eliminar-entry-export", "id_cabotage_weight_list", 'bi bi-trash3']];
    }
    this.output = {
      ...this.output,
      ...this.outputForm.value
    };
    if (this.router.url.includes('output-list')) {
      this.outputForm.reset({
        ...this.outputDetail[0],
        admission_date: this.outputDetail[0].departure_date.substring(0, 10),
      });
      if (this.movimiento === 'actualizar') {
        this.outputForm.get('customs_agreement_output')?.disable();
        this.outputForm.get('transport_type_id')?.disable();
        this.outputForm.get('railway_group')?.disable();
        this.changeTransport();
      }
      if (this.outputForm.get('customs_agreement_output')?.value === null) {
        this.entryTonnage = Number(this.outputForm.get('total_tonnage')?.value);
        this.entryPieces = Number(this.outputForm.get('total_pieces')?.value);
      }
      const customsAgreementOutput: null | 1 = this.transportList.length ? 1 : null;
      if (customsAgreementOutput) {
        this.outputForm.get('customs_agreement_output')?.setValue(customsAgreementOutput);
        this.changeCustomsAgreement();
      }
      this.outputForm.get('departure_date')?.setValue(this.outputDetail[0].departure_date.substring(0,10));
      if (this.outputDetail[0].id) {
        this.id = this.outputDetail[0].id;
      }
      this.outputForm.get('output_type_option_id')?.disable();
      if (this.movimiento === 'detalle') {
        this.outputForm.disable();
      }
      this.setTotalTonsPieces();
      this.updateTotals(this.transportList);
    }

    if (this.movimiento === 'crear' || this.movimiento === 'actualizar') {
      this.transportForm.get('no_bl')?.setValue(this.loteCabotajeService.loteInfoCabotage.bl_lot_id);
    }

    this.outputForm.get('railway_group')?.valueChanges.pipe(
      debounceTime(500)
    ).subscribe( value => {
      if (value && this.movimiento === 'crear') {
        this.hangleRailwayGroup(value);
      }
    });

    this.outputForm.get('total_tonnage')?.valueChanges
    .subscribe( value => {
      if (value) {
        this.entryTonnage = Number(value);
      } else {
        this.entryTonnage = 0;
      }
    });

    this.outputForm.get('total_pieces')?.valueChanges
    .subscribe( value => {
      if (value) {
        this.entryPieces = Number(value);
      } else {
        this.entryPieces = 0;
      }
    });

    this.transportForm.get('no_ticket')?.valueChanges
    .pipe(
      debounceTime(500)
    )
    .subscribe( ticket => {
      this.isValidModule = false;
      const ticketNumber = Number(ticket);
      const original_scale: string = this.outputForm.get('original_scale')?.value;
      const transport_type_id: string = this.outputForm.get('transport_type_id')?.value;
      const isSybasa = Number(original_scale) === 2;
      const isRailway = Number(transport_type_id) === 3;
      this.ticketChangeCount++;
      if ((this.movimiento === 'actualizar' && this.ticketChangeCount <= 1) || original_scale == '3') {
        return;
      }
      if (isRailway && isSybasa) {
        return;
      }
      if (
        ticketNumber > 0 &&
        Number.isInteger(ticketNumber) &&
        this.updateTranpostForm &&
        !this.qrResultString &&
        !this.scannerTextArea.value
      ) {
        this.loaderTicket = true;
        if (original_scale == '1') {
          this.hangleTicketTruckCooper(ticketNumber);
        } else if (original_scale == '2') {
          this.hangleTicketTruckSybasa(ticketNumber);
        }
      }
    });

    this.formTransportLine.valueChanges
    .subscribe(value => {
      if (value)
        this.outputForm.get('transport_line_id')?.setValue(value);
    });

    this.transportLine.valueChanges.pipe(
      debounceTime(500)
    ).subscribe(value => {
      this.getTransportLines(value.toUpperCase());
    });
  }

  /**
   * Valida y envía el formulario para crear o actualizar la salida por acuerdo aduanal del lote de cabotaje,
   * verificando los anexos, registros de transporte y tonelaje, y mostrando los mensajes correspondientes.
   */
  saveOutput() {
    if (!this.authService.isValidPath('cabotage', 'outputs', 'create')) {
      return;
    }
    const isExportCabotage = !this.router.url.includes('ship-list');
    if (this.movimiento === 'crear') {
      if (!this.cabotageBatch[0].keys_files?.length && isExportCabotage) {
        this.mensajeOverlay = 'No se puede registrar salida porque el lote no tiene anexos';
        this.iconoOverlay = 'bi bi-info-circle-fill';
        this.buttons = false;
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        },4000)
        return;
      }
    }
    const invalidLocationsForm = this.amountsComponent.isInvalidForm();
    if (this.outputForm.invalid || invalidLocationsForm) {
      this.outputForm.markAllAsTouched();
      this.mensajeOverlay = 'Favor de verificar la información';
      this.iconoOverlay = 'bi bi-exclamation-circle-fill';
      this.buttons = false;
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },2000);
      return;
    }
    let newList: any[] = [];
    if (this.outputForm.get('customs_agreement_output')?.value === null) {
      if (Number(this.outputForm.get('total_tonnage')?.value) === 0 && !this.outputForm.get('total_pieces')?.value) {
        this.mensajeOverlay =
          this.outputForm.get('total_pieces')?.value == 0
          ? 'No es posible hacer un registro con tonelaje y número de piezas en 0'
          : 'No es posible hacer un registro con tonelaje en 0 o menor';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        },4000);
        return;
      }
    } else {
      if (!this.transportList.length) {
        this.mensajeOverlay = 'Favor de agregar un registro de transporte';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        },4000)
        return;
      }
      const trailer = this.outputForm.get('trailer_id')?.value;
      const transportType = this.outputForm.get('transport_type_id')?.value;
      if (transportType == 1 && trailer == 1 && this.transportList.length > 1) {
        this.mensajeOverlay = 'Favor de eliminar un registro de transporte';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        },4000)
        return;
      }
      newList = [...this.transportList.map(item => ({
        gross_weight: item.gross_weight,
        no_ticket: item.no_ticket ? String(item.no_ticket) : null,
        plate: item.plate,
        quantity_pieces: item.quantity_pieces,
        tare_weight: item.tare_weight,
        no_slab: item.no_slab ? item.no_slab : null,
        no_cast: item.no_cast,
        no_bl: item.no_bl,
      }))];
    }
    this.loading = true;
    this.output = {
      ...this.output,
      ...this.outputForm.value,
      cabotage_batch_id: this.batchValue,
      precinct_key: 201,
      request_number: null,
      ship_number: !isExportCabotage ? this.blDetails.operation_number : null,
      ship_name: !isExportCabotage ? this.getShipNameByNumber(this.blDetails.operation_number) : null,
      total_tonnage: Number(this.outputForm.get('total_tonnage')?.value) || 1,
      total_pieces: Number(this.outputForm.get('total_pieces')?.value) || 0,
      checker_name: this.outputForm.get('checker_name')?.value,
      output_type_option_id: Number(this.tipoSalida.value),
      departure_date: this.outputForm.get('departure_date')?.value + ' 00:00:00',
      transport_type_id: this.outputForm.get('transport_type_id')?.value ? Number(this.outputForm.get('transport_type_id')?.value) : null,
      trailer_id: Number(this.outputForm.get('transport_type_id')?.value) === 1 ? Number(this.outputForm.get('trailer_id')?.value) : null,
      original_scale: this.outputForm.get('original_scale')?.value ? Number(this.outputForm.get('original_scale')?.value) : null,
      railway_group: this.outputForm.get('railway_group')?.value ? Number(this.outputForm.get('railway_group')?.value) : null,
      transport_line_id: this.outputForm.get('transport_line_id')?.value ? Number(this.outputForm.get('transport_line_id')?.value) : null,
      customs_agreement_output: newList.length ? 1 : null
    };
    if (this.movimiento === 'actualizar') {
      this.output = {
        ...this.output,
        id: this.outputDetail[0].id,
      };
      if (this.outputForm.get('customs_agreement_output')?.value == 1) {
        this.output.total_tonnage = 1;
      }
      this.mensajeOverlay = 'La salida fue actualizada de manera correcta';
      this.iconoOverlay = 'bi bi-check2';
      this.buttons = false;
      this.loteCabotajeService.updateCabotageOutput(this.output)
      .subscribe({
        next: response => {
          if (response.error) {
            this.mensajeOverlay = response.message.includes('tonnage')
            ? 'La suma de toneladas es mayor a las toneladas de entrada'
            : response.message.includes('pieces')
            ? 'La suma de piezas es mayor a las piezas totales de entrada'
            : 'Lo sentimos no fue posible registrar la salida, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.buttons = false;
            this.loading = false;
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 4000);
            return;
          }
          this.loteCabotajeService.getCabotageBatch(this.batchValue)
          .subscribe({
            next: batch => {
              this.loteCabotajeService.loteInfoCabotage = batch[0];
              const inputTons = batch[0].input_tons;
              const outputTons = Number(batch[0].output_tons?.toFixed(3));
              const twoPercent = inputTons ? inputTons * 0.02 : 0;
              let inputTons_twoPercent = Number(inputTons) + Number(twoPercent);
              inputTons_twoPercent = Number(inputTons_twoPercent.toFixed(3));
              this.loading = false;
              this.overlay = true;
              if (outputTons > inputTons_twoPercent) {
                setTimeout(() => {
                  this.mensajeOverlay = 'Tonelaje ha exedido mas del 2%';
                  this.iconoOverlay = 'bi bi-exclamation-circle-fill';
                  setTimeout(() => {
                    this.overlay = false;
                    this.regresar();
                  }, 3000);
                }, 2000);
                return;
              }
              setTimeout(() => {
                this.overlay = false;
                this.regresar();
              }, 2000);
            },
            error: (e) => {
              this.mensajeOverlay = 'Error en el servidor al actualizar el lote, inténtelo más tarde';
              this.iconoOverlay = 'bi bi-exclamation-circle-fill';
              this.buttons = false;
              this.loading = false;
              this.overlay = true;
              setTimeout(() => {
                this.overlay = false;
              }, 3000);
            },
          });
        },
        error: (e) => {
          this.mensajeOverlay = 'Error en el servidor al actualizar el registro, inténtelo más tarde';
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.buttons = false;
          this.loading = false;
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
        },
      });
      return;
    }
    this.mensajeOverlay = 'La salida fue agregada de manera correcta';
    this.iconoOverlay = 'bi bi-check2';
    this.buttons = false;
    if (this.outputForm.get('customs_agreement_output')?.value === 1) {
      this.output.weight_list = [...newList];
    }
    this.loteCabotajeService.createCabotageOutput(this.output)
    .subscribe({
      next: response => {
        if (response.error) {
          this.mensajeOverlay = response.message.includes('tonnage')
          ? 'La suma de toneladas es mayor a las toneladas de entrada'
          : response.message.includes('pieces')
          ? 'La suma de piezas es mayor a las piezas totales de entrada'
          : 'Lo sentimos no fue posible registrar la salida, inténtelo más tarde';
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.buttons = false;
          this.loading = false;
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 4000);
          return;
        }
        this.loteCabotajeService.getCabotageBatch(this.batchValue)
        .subscribe({
          next: batch => {
            this.loteCabotajeService.loteInfoCabotage = batch[0];
            const inputTons = batch[0].input_tons;
            const outputTons = Number(batch[0].output_tons?.toFixed(3));
            const twoPercent = inputTons ? inputTons * 0.02 : 0;
            let inputTons_twoPercent = Number(inputTons) + Number(twoPercent);
            inputTons_twoPercent = Number(inputTons_twoPercent.toFixed(3));
            this.loading = false;
            this.overlay = true;
            if (outputTons > inputTons_twoPercent) {
              setTimeout(() => {
                this.mensajeOverlay = 'Tonelaje ha exedido mas del 2%';
                this.iconoOverlay = 'bi bi-exclamation-circle-fill';
                setTimeout(() => {
                  this.overlay = false;
                  if (this.router.url.includes('/ship-list')) {
                    this.router.navigate([`/ship-list/${this.blDetails.operation_number}/cabotage/batch-movement/output-list`, this.batchValue]);
                  } else {
                    this.router.navigate([`/cabotage/batch-movement/output-list`, this.batchValue])
                  }
                }, 3000);
              }, 2000);
              return;
            }
            setTimeout(() => {
              this.overlay = false;
              if (this.router.url.includes('/ship-list')) {
                this.router.navigate([`/ship-list/${this.blDetails.operation_number}/cabotage/batch-movement/output-list`, this.batchValue]);
              } else {
                this.router.navigate([`/cabotage/batch-movement/output-list`, this.batchValue])
              }
            }, 2000);
          },
          error: (e) => {
            this.mensajeOverlay = 'Error en el servidor al actualizar el lote, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.buttons = false;
            this.loading = false;
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 3000);
          },
        });
      },
      error: (e) => {
        this.mensajeOverlay = 'Error en el servidor al crear el registro, inténtelo más tarde';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.buttons = false;
        this.loading = false;
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
      },
    });
  }

  /**
   * Indica si un campo del formulario de salida es inválido y ha sido tocado por el usuario.
   * @param campo - Nombre del control del formulario a validar.
   * @returns `true` si el campo tiene errores y fue tocado; de lo contrario `null` o `false`.
   */
  campoEsValido( campo: string): boolean | null {
    return this.outputForm.get(campo)!.errors &&
    this.outputForm.get(campo)!.touched;
  }

  /**
   * Procesa el archivo seleccionado para un campo del formulario, validando su tamaño
   * y convirtiéndolo a base64.
   * @param event - Evento del input de tipo archivo.
   * @param campo - Nombre del control del formulario donde se asigna el archivo.
   */
  fileInput(event: any, campo: string): void {
    if (event.target.files[0]) {
      if (event.target.files[0].size > 20 * 1024 * 1024) {
        switch (campo) {
          case 'customs_agreement_document':
            this.mensajeError = 'El archivo tiene que ser menos a 20mb';
            this.maxSize = true;
            break;
        }
        this.outputForm.get(campo)?.setValue('');
        return;
      }
      this.maxSize = false;
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const cadena = reader.result?.toString() || '';
        const contenidoBase64 = cadena.split(',')[1];
        this.outputForm.get(campo)?.setValue(contenidoBase64);
      }
    } else {
      switch (campo) {
        case 'customs_agreement_document':
          this.mensajeError = 'Ingrese el archivo';
          break;
      }
      this.outputForm.get(campo)?.setValue('');
    }
  }

  /**
   * Ordena un arreglo de manera ascendente según la clave indicada.
   * @param array - Arreglo de elementos a ordenar.
   * @param key - Clave del elemento por la cual se ordena.
   * @returns El arreglo ordenado.
   */
  sortArray<T>(array: T[], key: keyof T): T[] {
    return array = array.sort(function (a, b) {
      if (a[key] > b[key]) {
        return 1;
      }
      if (a[key] < b[key]) {
        return -1;
      }
      return 0;
    });
  }

  /**
   * Emite el evento para regresar a la vista anterior del flujo de salidas.
   */
  regresar() {
    this.onRegresar.emit(true);
  }

  /**
   * Alterna la visibilidad del overlay de selección de línea de transporte
   * cuando el movimiento es de creación o actualización.
   */
  togleOverlayTransportLine() {
    if (this.movimiento === 'crear' || this.movimiento === 'actualizar') {
      this.transportLineOverlay = !this.transportLineOverlay;
    }
  }

  /**
   * Filtra la lista de líneas de transporte por la descripción que contenga el valor indicado.
   * @param value - Texto de búsqueda para filtrar las líneas de transporte.
   */
  getTransportLines(value: string) {
    this.loaderTransportLine = true;
    this.listTransportLineFilter = this.listTransportLine.filter(transportLine => {
      return transportLine.description.includes(value);
    });
    this.loaderTransportLine = false;
  }

  /**
   * Consulta el ticket de báscula de Cooper por su número y rellena el formulario de transporte
   * con los pesos y placas obtenidos, validando que sea un ticket válido.
   * @param ticketNumber - Número de folio del ticket de báscula a consultar.
   */
  hangleTicketTruckCooper(ticketNumber: number) {
    this.scaleTicketSvc.getScaleTicket(ticketNumber)
    .subscribe({
      next: scaleTicket => {
        if ( Array.isArray(scaleTicket) && scaleTicket.length ) {
          if (scaleTicket[0].operation_type !== 2) {
            this.resetTransportForm();
            this.messageTicket = 'Número de folio ticket no válido para exportación';
            this.isValidModule = true;
            this.loaderTicket = false;
            return;
          }
          if (scaleTicket[0].status === false) {
            this.resetTransportForm();
            this.messageTicket = 'Boleta de báscula en captura';
            this.isValidModule = true;
            this.loaderTicket = false;
            return;
          }
          if (scaleTicket[0].status_ticket === false) {
            this.resetTransportForm();
            this.messageTicket = 'Boleta de báscula cancelada';
            this.isValidModule = true;
            this.loaderTicket = false;
            return;
          }
          this.transportForm.get('gross_weight')?.setValue(Number(scaleTicket[0].gross_weight) > 0 ? Number(scaleTicket[0].gross_weight) / 1000 : 0);
          this.transportForm.get('tare_weight')?.setValue(Number(scaleTicket[0].tare_weight) > 0 ? Number(scaleTicket[0].tare_weight) / 1000 : 0);
          this.transportForm.get('plate')?.setValue(scaleTicket[0].plates);
          this.weightTransportChange();
        } else {
          this.resetTransportForm();
          this.messageTicket = 'Número de folio ticket no existe';
          this.isValidModule = true;
        }
        this.loaderTicket = false;
      },
      error: (e) => {
        this.mensajeOverlay = 'Error en el servidor al cargar el ticket, inténtelo más tarde';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.buttons = false;
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
      },
    });
  }

  /**
   * Consulta el ticket de báscula de Sybasa por su número y rellena el formulario de transporte
   * con los pesos y placas obtenidos.
   * @param ticketNumber - Número de folio del ticket de báscula a consultar.
   */
  hangleTicketTruckSybasa(ticketNumber: number) {
    const departure_date = new Date(this.outputForm.get('departure_date')?.value);
    const year = departure_date.getFullYear();
    this.scaleTicketSvc.getScaleTicketTruckSybasa({
      transport_type_id: 1,
      ticket_number: ticketNumber,
      scale_key: 'SYBC',
      year: year
    }).subscribe({
      next: scaleTicketSybasa => {
        if ( Array.isArray(scaleTicketSybasa) && scaleTicketSybasa.length ) {
          this.transportForm.get('gross_weight')?.setValue(Number(scaleTicketSybasa[0].gross_weight) > 0 ? Number(scaleTicketSybasa[0].gross_weight) / 1000 : 0);
          this.transportForm.get('tare_weight')?.setValue(Number(scaleTicketSybasa[0].tare_weight) > 0 ? Number(scaleTicketSybasa[0].tare_weight) / 1000 : 0);
          this.transportForm.get('plate')?.setValue(scaleTicketSybasa[0].plates);
          this.weightTransportChange();
        } else {
          this.resetTransportForm();
          const response: any = scaleTicketSybasa;
          if (response.error) {
            this.loaderTicket = false;
            this.mensajeOverlay = 'Error en el servidor al cargar el ticket, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 3000);
            return;
          }
          this.messageTicket = 'Número de folio ticket no existe';
          this.isValidModule = true;
        }
        this.loaderTicket = false;
      },
      error: e => {
        this.loaderTicket = false;
        this.mensajeOverlay = 'Error en el servidor al cargar el ticket, inténtelo más tarde';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.buttons = false;
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
      }
    });
  }

  /**
   * Consulta los tickets de báscula de un grupo ferroviario de Sybasa y carga los registros de transporte asociados.
   * @param value - Número del grupo ferroviario a consultar.
   */
  hangleRailwayGroup(value: any) {
    if (!this.outputForm.get('departure_date')?.value) {
      this.outputForm.get('railway_group')?.setValue('');
      this.mensajeOverlay = 'Ingrese la fecha';
      this.iconoOverlay = 'bi bi-info-circle-fill';
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },2000);
      return;
    }
    const departure_date = new Date(this.outputForm.get('departure_date')?.value);
    const year = departure_date.getFullYear();
    this.loaderRailwayGroup = true;
    this.scaleTicketSvc.getScaleTicketRailwaySybasa({
      transport_type_id: 2,
      ticket_number: Number(value),
      scale_key: 'SYBC',
      year: year
    }).subscribe({
      next: scaleTicketsRailway => {
        if (!Array.isArray(scaleTicketsRailway)) {
          this.loaderRailwayGroup = false;
          this.mensajeOverlay = 'Error en la base de datos, favor de intentarlo de nuevo';
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          },2000);
          return;
        }
        this.transportList = [];
        scaleTicketsRailway.forEach( (ticket, index) => {
          this.transportList.push({
            id: index,
            gross_weight: Number(ticket.gross_weight) > 0 ? ticket.gross_weight / 1000 : 0,
            tare_weight:  Number(ticket.tare_weight) > 0 ? ticket.tare_weight / 1000 : 0,
            quantity_pieces: 0,
            plate: ticket.unit + ticket.number,
            no_ticket: ticket.id,
            no_slab: null,
            no_cast: null,
            no_bl: this.loteCabotajeService.loteInfoCabotage.bl_lot_id,
            net_weight: Number(ticket.net_weight) > 0 ? ticket.net_weight / 1000 : 0
          });
        });
        this.setTotalTonsPieces();
        this.updateTotals(this.transportList);
        this.loaderRailwayGroup = false;
      },
      error: e => {
        this.loaderRailwayGroup = false;
        this.mensajeOverlay = 'Error en el servidor al cargar los tickets, inténtelo más tarde';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.buttons = false;
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
      }
    });
  }

  // Transport
  /**
   * Habilita el formulario de transporte y muestra el overlay para crear un nuevo registro de transporte.
   */
  showCreateTransport() {
    this.transportForm.enable();
    this.overlayTransport = !this.overlayTransport;
  }

  /**
   * Prepara y muestra el formulario para crear un nuevo registro de transporte.
   */
  createTransport() {
    this.updateTranpostForm = true;
    this.transportForm.enable();
    this.updateTransport = false;
    this.addTransport = true;
    this.transportForm.reset();
    this.transportForm.reset({
      quantity_pieces: 0,
      no_bl: this.loteCabotajeService.loteInfoCabotage.bl_lot_id,
      no_slab: ''
    });
    this.net_weight = 0;
    const transportType = this.outputForm.get('transport_type_id')?.value;
    const trailerType = this.outputForm.get('trailer_id')?.value;
    const originTicket = this.outputForm.get('original_scale')?.value;
    const departure_date = this.outputForm.get('departure_date')?.value;
    if (!departure_date) {
      this.mensajeOverlay = 'Ingrese la fecha';
      this.iconoOverlay = 'bi bi-info-circle-fill';
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },2000);
      return;
    }
    if (!transportType) {
      this.mensajeOverlay = 'Selecciona un tipo de transporte';
      this.iconoOverlay = 'bi bi-info-circle-fill';
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },3000);
      return;
    }
    if (!originTicket) {
      this.mensajeOverlay = 'Selecciona un tipo de báscula';
      this.iconoOverlay = 'bi bi-info-circle-fill';
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },3000);
      return;
    }
    if (transportType == '3') {
      this.overlayTransport = !this.overlayTransport;
    }
    if (transportType == '1') {
      if (trailerType == '1') {
        if (!this.transportList.length) {
          this.overlayTransport = !this.overlayTransport;
        } else {
          this.mensajeOverlay = 'No es posible agregar otro registro cuando remolque es sencillo';
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          },4000);
          return;
        }
      } else if (trailerType == '2') {
        if (this.transportList.length < 2) {
          this.overlayTransport = !this.overlayTransport;
        } else {
          this.mensajeOverlay = 'No es posible agregar otro registro cuando remolque es full';
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          },4000);
          return;
        }
      } else {
        this.mensajeOverlay = 'Selecciona un tipo de remolque';
        this.iconoOverlay = 'bi bi-info-circle-fill';
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        },3000);
        return;
      }
    }
  }

  /**
   * Muestra la confirmación para crear el registro de transporte.
   */
  confirmCreateForm() {
    this.confirmCreate = true;
  }

  /**
   * Guarda o cancela el registro de transporte capturado según la acción indicada.
   * @param cancel - Indicador que determina si se cancela la operación.
   */
  saveTransport(cancel: string) {
    this.confirmCreate = false;
    if (cancel) {
      return;
    }
    if( this.transportForm.invalid ) {
      this.transportForm.markAllAsTouched();
      this.mensajeOverlay = 'Favor de verificar la información';
      this.iconoOverlay = 'bi bi-exclamation-circle-fill';
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },2000);
      return;
    }
    if (this.net_weight <= 0) {
      this.mensajeOverlay = 'No es posible hacer un registro con tonelaje en 0 o menor';
      this.iconoOverlay = 'bi bi-exclamation-circle-fill';
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },4000);
      return;
    }
    this.showCreateTransport();
    if (this.movimiento === 'actualizar') {
      const transport = {
        ...this.transportForm.value,
        net_weight: this.net_weight,
        output_id: this.outputDetail[0].id,
        quantity_pieces: this.transportForm.get('quantity_pieces')?.value ? Number(this.transportForm.get('quantity_pieces')?.value) : 0,
        gross_weight: Number(this.transportForm.get('gross_weight')?.value),
        tare_weight: Number(this.transportForm.get('tare_weight')?.value),
      };
      this.loading = true;
      if (this.addTransport) {
        this.loteCabotajeService.createCabotageTransportOutput(transport)
        .subscribe({
          next: response => {
            if (response.error) {
            this.loading = false;
              this.mensajeOverlay = response.message.includes('tonnage')
                ? 'La suma de toneladas de salidas es mayor a las toneladas de entrada'
                : response.message.includes('pieces')
                ? 'La suma de piezas de salidas es mayor a las piezas del entrada'
                : 'Lo sentimos no fue posible crear el registro, inténtelo más tarde';
              this.iconoOverlay = 'bi bi-exclamation-circle-fill';
              this.loading = false;
              this.overlay = true;
              setTimeout(() => {
                this.overlay = false;
              },4000);
              return;
            }
            this.loteCabotajeService.getCabotageBatch(this.batchValue)
            .subscribe({
              next: lote => {
                this.loteCabotajeService.loteInfoCabotage = lote[0];
                const idOutput = this.outputDetail[0].id || 0;
                this.loteCabotajeService.getCabotageTransportListByOutput(idOutput)
                .subscribe({
                  next: transports => {
                    this.transportList = [...transports];
                    this.setTotalTonsPieces();
                    this.updateTotals(this.transportList);
                    this.mensajeOverlay = 'Registro agregado correctamente';
                    this.iconoOverlay = 'bi bi-check2';
                    this.loading = false;
                    this.overlay = true;
                    setTimeout(() => {
                      this.overlay = false;
                      this.net_weight = 0;
                      this.transportForm.reset({
                        quantity_pieces: 0,
                        no_bl: this.loteCabotajeService.loteInfoCabotage.bl_lot_id,
                      });
                    },2000);
                  },
                  error: (e) => {
                    this.loading = false;
                    this.mensajeOverlay = 'Error en el servidor al cargar los transportes, inténtelo más tarde';
                    this.iconoOverlay = 'bi bi-exclamation-circle-fill';
                    this.overlay = true;
                    setTimeout(() => {
                      this.overlay = false;
                    }, 3000);
                  },
                });
              },
              error: (e) => {
                this.loading = false;
                this.mensajeOverlay = 'Error en el servidor al actualizar el lote, inténtelo más tarde';
                this.iconoOverlay = 'bi bi-exclamation-circle-fill';
                this.overlay = true;
                setTimeout(() => {
                  this.overlay = false;
                }, 3000);
              },
            });
          },
          error: (e) => {
            this.loading = false;
            this.mensajeOverlay = 'Error en el servidor al crear el registro, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 3000);
          },
        });
        return;
      } else {
        transport.id = this.currentIdTransport;
        this.loteCabotajeService.updateCabotageTransportOutput(transport)
        .subscribe({
          next: response => {
            if (response.error) {
            this.loading = false;
              this.mensajeOverlay = response.message.includes('tonnage')
                ? 'La suma de toneladas de salidas es mayor a las toneladas de entrada'
                : response.message.includes('pieces')
                ? 'La suma de piezas de salidas es mayor a las piezas del entrada'
                : 'Lo sentimos no fue posible actualizar el registro, inténtelo más tarde';
              this.iconoOverlay = 'bi bi-exclamation-circle-fill';
              this.loading = false;
              this.overlay = true;
              setTimeout(() => {
                this.overlay = false;
              },4000);
              return;
            }
            this.loteCabotajeService.getCabotageBatch(this.batchValue)
            .subscribe({
              next: lote => {
                this.loteCabotajeService.loteInfoCabotage = lote[0];
                const idOutput = this.outputDetail[0].id || 0;
                this.loteCabotajeService.getCabotageTransportListByOutput(idOutput)
                .subscribe({
                  next: transports => {
                    this.transportList = [...transports];
                    this.setTotalTonsPieces();
                    this.updateTotals(this.transportList);
                    this.mensajeOverlay = 'Registro actualizado correctamente';
                    this.iconoOverlay = 'bi bi-check2';
                    this.loading = false;
                    this.overlay = true;
                    setTimeout(() => {
                      this.overlay = false;
                      this.net_weight = 0;
                      this.transportForm.reset({
                        quantity_pieces: 0,
                        no_bl: this.loteCabotajeService.loteInfoCabotage.bl_lot_id,
                      });
                    },2000);
                  },
                  error: (e) => {
                    this.loading = false;
                    this.mensajeOverlay = 'Error en el servidor al cargar los transportes, inténtelo más tarde';
                    this.iconoOverlay = 'bi bi-exclamation-circle-fill';
                    this.overlay = true;
                    setTimeout(() => {
                      this.overlay = false;
                    }, 3000);
                  },
                });
              },
              error: (e) => {
                this.loading = false;
                this.mensajeOverlay = 'Error en el servidor al actualizar el lote, inténtelo más tarde';
                this.iconoOverlay = 'bi bi-exclamation-circle-fill';
                this.overlay = true;
                setTimeout(() => {
                  this.overlay = false;
                }, 3000);
              },
            });
          },
          error: (e) => {
            this.loading = false;
            this.mensajeOverlay = 'Error en el servidor al actualizar el registro, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 3000);
          },
        });
        return;
      }
    }
    this.net_weight = Number(this.transportForm.get('gross_weight')?.value) - Number(this.transportForm.get('tare_weight')?.value);
    const transport = {
      id: this.idCount,
      ...this.transportForm.value,
      net_weight: this.net_weight,
      quantity_pieces: this.transportForm.get('quantity_pieces')?.value ? Number(this.transportForm.get('quantity_pieces')?.value) : 0,
      gross_weight: Number(this.transportForm.get('gross_weight')?.value),
      tare_weight: Number(this.transportForm.get('tare_weight')?.value),
    };
    this.idCount++;
    this.net_weight = 0;
    this.transportForm.reset({
      quantity_pieces: 0,
      no_bl: this.loteCabotajeService.loteInfoCabotage.bl_lot_id
    });
    if (this.addTransport) {
      this.transportList.push(transport);
      this.mensajeOverlay = 'Registro agregado correctamente';
    } else {
      this.mensajeOverlay = 'Registro actualizado correctamente';
      const index = this.transportList.findIndex( transport => transport.id === this.currentIdTransport );
      this.transportList[index] = {...transport, id: this.transportList[index].id };
    }
    this.setTotalTonsPieces();
    this.updateTotals(this.transportList);
    this.iconoOverlay = 'bi bi-check2';
    this.overlay = true;
    setTimeout(() => {
      this.overlay = false;
    },2000);
  }

  /**
   * Marca un registro de transporte para su eliminación mostrando la confirmación correspondiente.
   * @param id - Identificador del registro de transporte a eliminar.
   */
  confirm(id: number) {
    this.currentTransportId = id;
    this.transportDelete = true;
  }

  /**
   * Elimina el registro de transporte previamente seleccionado o cancela la operación.
   * @param cancelar - Indicador que determina si se cancela la eliminación.
   */
  deleteTransport( cancelar: string ) {
    if ( cancelar ) {
      this.transportDelete = false;
      return;
    }
    this.transportDelete = false;
    if (this.movimiento === 'actualizar') {
      if (this.transportList.length === 1) {
        this.mensajeOverlay = 'Tiene que haber por lo menos un registro';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.loading = false;
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        },4000);
        return;
      }
      this.loading = true;
      this.loteCabotajeService.deleteCabotageTransportOutput(this.currentTransportId)
      .subscribe({
        next: response => {
          if (response.error) {
            this.mensajeOverlay = 'Lo sentimos no fue posible eliminar el registro, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-info-circle-fill';
            this.loading = false;
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            },3000);
            return;
          }
          this.loteCabotajeService.getCabotageBatch(this.batchValue)
          .subscribe({
            next: batch => {
              this.loteCabotajeService.loteInfoCabotage = batch[0];
              const idOutput = this.outputDetail[0].id || 0;
              this.loteCabotajeService.getCabotageTransportListByOutput(idOutput)
              .subscribe({
                next: transports => {
                  this.transportList = [...transports];
                  this.setTotalTonsPieces();
                  this.updateTotals(this.transportList);
                  this.mensajeOverlay = 'Registro eliminado correctamente';
                  this.iconoOverlay = 'bi bi-check2';
                  this.loading = false;
                  this.overlay = true;
                  setTimeout(() => {
                    this.overlay = false;
                  },2000);
                },
                error: (e) => {
                  this.loading = false;
                  this.mensajeOverlay = 'Error en el servidor al cargar los transportes, inténtelo más tarde';
                  this.iconoOverlay = 'bi bi-exclamation-circle-fill';
                  this.buttons = false;
                  this.overlay = true;
                  setTimeout(() => {
                    this.overlay = false;
                  }, 3000);
                },
              });
            },
            error: (e) => {
              this.loading = false;
              this.mensajeOverlay = 'Error en el servidor al actualizar el lote, inténtelo más tarde';
              this.iconoOverlay = 'bi bi-exclamation-circle-fill';
              this.buttons = false;
              this.overlay = true;
              setTimeout(() => {
                this.overlay = false;
              }, 3000);
            },
          });
        },
        error: (e) => {
          this.loading = false;
          this.mensajeOverlay = 'Error en el servidor al eliminar el registro, inténtelo más tarde';
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.buttons = false;
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
        },
      });
      return;
    }
    const index = this.transportList.findIndex( item => item.id === this.currentTransportId);
    this.transportList.splice(index, 1);
    this.transportDelete = false;
    this.transportForm.markAllAsTouched();
    this.setTotalTonsPieces();
    this.updateTotals(this.transportList);
    this.mensajeOverlay = 'Registro eliminado correctamente';
    this.iconoOverlay = 'bi bi-check2';
    this.overlay = true;
    setTimeout(() => {
      this.overlay = false;
    },2000);
  }

  /**
   * Ajusta los validadores y campos del formulario en función del tipo de transporte seleccionado.
   */
  changeTransport() {
    const transportType = this.outputForm.get('transport_type_id')?.value;
    this.outputForm.get('trailer_id')?.clearValidators();
    this.outputForm.get('tractor_plates')?.clearValidators();
    if (this.movimiento === 'crear') {
      this.outputForm.get('trailer_id')?.setValue('');
      this.outputForm.get('tractor_plates')?.setValue('');
      this.transportList = [];
      this.changeOriginTicket();
    }
    if (transportType == '1') {
      this.outputForm.get('trailer_id')?.addValidators([Validators.required]);
      this.outputForm.get('tractor_plates')?.addValidators([Validators.required]);
    }
    this.outputForm.get('trailer_id')?.updateValueAndValidity();
    this.outputForm.get('tractor_plates')?.updateValueAndValidity();
  }

  /**
   * Calcula el peso neto del transporte a partir del peso bruto y la tara capturados.
   */
  weightTransportChange() {
    if (this.transportForm.get('gross_weight')?.value !== null && this.transportForm.get('tare_weight')?.value !== null) {
      let neto = Number(this.transportForm.get('gross_weight')?.value) - Number(this.transportForm.get('tare_weight')?.value);
      neto = Number(neto.toFixed(3));
      this.net_weight = neto;
    }
  }

  /**
   * Indica si un campo del formulario de transporte es inválido y ha sido tocado por el usuario.
   * @param campo - Nombre del control del formulario de transporte a validar.
   * @returns `true` si el campo tiene errores y fue tocado; de lo contrario `null` o `false`.
   */
  isValidTransport( campo: string): boolean | null {
    return this.transportForm.get(campo)!.errors &&
    this.transportForm.get(campo)!.touched;
  }

  /**
   * Ajusta el formulario y los validadores según la opción de salida con acuerdo aduanal seleccionada.
   */
  changeCustomsAgreement() {
    const customsAgreementOutput = this.outputForm.get('customs_agreement_output')?.value;
    if (customsAgreementOutput === null) {
      this.outputForm.reset();
      const fullName = this.localStorageSvc.getFullName();
      const isCheckerNameDisabled = fullName ? true : false;
      this.outputForm.get('"trailer_id"')?.clearValidators();
      this.outputForm.get('"plate_van_boat_number"')?.clearValidators();
      this.outputForm.get('"operator_name"')?.clearValidators();
      this.outputForm.get('transport_type_id')?.clearValidators();
      this.outputForm.get('transport_line_id')?.clearValidators();
      this.outputForm.get('destiny')?.clearValidators();
      this.outputForm.get('company_destiny')?.clearValidators();
      this.outputForm.get('customs_agent')?.clearValidators();
      this.outputForm.get('transport_line_id')?.updateValueAndValidity();
      this.outputForm.get('destiny')?.updateValueAndValidity();
      this.outputForm.get('company_destiny')?.updateValueAndValidity();
      this.outputForm.get('customs_agent')?.updateValueAndValidity();
      this.outputForm.get('transport_type_id')?.updateValueAndValidity();
      this.outputForm.get('trailer_id')?.updateValueAndValidity();
      this.outputForm.get('plate_van_boat_number')?.updateValueAndValidity();
      this.outputForm.get('operator_name')?.updateValueAndValidity();
      this.outputForm.get('total_tonnage')?.addValidators([Validators.required, Validators.pattern(/^(?!0\d)\d{0,11}(?:\.\d{1,3})?$/)]);
      this.outputForm.get('checker_name')?.setValue(fullName);
      this.outputForm.get('checker_name')?.disable({onlySelf: isCheckerNameDisabled});
    } else {
      this.outputForm.get('total_tonnage')?.reset();
      this.outputForm.get('total_pieces')?.reset();
      this.outputForm.get('total_tonnage')?.clearValidators();
      this.outputForm.get('total_pieces')?.clearValidators();
      this.outputForm.get('total_tonnage')?.updateValueAndValidity();
      this.outputForm.get('total_pieces')?.updateValueAndValidity();
      this.outputForm.get('transport_type_id')?.addValidators([Validators.required]);
      this.outputForm.get('transport_line_id')?.addValidators([Validators.required]);
      this.outputForm.get('destiny')?.addValidators([Validators.required]);
      this.outputForm.get('company_destiny')?.addValidators([Validators.required]);
      this.outputForm.get('customs_agent')?.addValidators([Validators.required]);
      this.outputForm.get('transport_line_id')?.updateValueAndValidity();
      this.outputForm.get('destiny')?.updateValueAndValidity();
      this.outputForm.get('company_destiny')?.updateValueAndValidity();
      this.outputForm.get('customs_agent')?.updateValueAndValidity();
      this.outputForm.get('transport_type_id')?.updateValueAndValidity();
    }
    const fullName = this.localStorageSvc.getFullName();
    const isCheckerNameDisabled = fullName ? true : false;
    this.outputForm.get('checker_name')?.setValue(fullName);
    if (isCheckerNameDisabled) {
      this.outputForm.get('checker_name')?.disable()
    }
  }

  /**
   * Reacciona al cambio de báscula de origen reiniciando los registros de transporte cuando corresponde.
   */
  changeOriginTicket() {
    if (this.movimiento === 'actualizar') {
      if (this.transportList.length) {
        this.mensajeOverlay = 'Esta acción eliminará todos los registros de transporte. ¿Está seguro?';
        this.iconoOverlay = '';
        this.buttons = true;
        this.overlay = true;
      } else {
        this.outputDetail[0].original_scale = this.outputForm.get('original_scale')?.value;
      }
    }
    this.outputForm.get('railway_group')?.clearValidators();
    this.outputForm.get('railway_group')?.setValue('');
    const currentOriginTicket = this.outputForm.get('original_scale')?.value;
    const currentTransportType = this.outputForm.get('transport_type_id')?.value;
    if (currentOriginTicket == '2' && currentTransportType == '3') {
      this.outputForm.get('railway_group')?.addValidators([Validators.required]);
    }
    this.outputForm.get('railway_group')?.updateValueAndValidity();
  }

  /**
   * Elimina todos los registros de transporte de la salida o cancela la operación.
   * @param cancel - Indicador que determina si se cancela la eliminación masiva.
   */
  deleteAllTransport(cancel: string) {
    this.overlay = false;
    if (cancel) {
      this.outputForm.get('original_scale')?.setValue(this.outputDetail[0].original_scale);
      return;
    } else {
      this.outputDetail[0].original_scale = this.outputForm.get('original_scale')?.value;
    }
    this.buttons = false;
    this.loading = true;
    this.loteCabotajeService.deleteAllCabotageTransportOutput(this.outputDetail[0].id || 0)
    .subscribe({
      next: response => {
        if (response.error) {
          this.mensajeOverlay = 'Lo sentimos no fue posible eliminar los registros, inténtelo más tarde';
          this.iconoOverlay = 'bi bi-info-circle-fill';
          this.loading = false;
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          },4000);
          return;
        }
        this.transportList = [];
        this.setTotalTonsPieces();
        this.updateTotals(this.transportList);
        this.loteCabotajeService.getCabotageBatch(this.batchValue)
        .subscribe({
          next: batch => {
            this.loteCabotajeService.loteInfoCabotage = batch[0];
            this.mensajeOverlay = 'Registros eliminados correctamente';
            this.iconoOverlay = 'bi bi-check2';
            this.loading = false;
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            },2000);
          },
          error: (e) => {
            this.loading = false;
            this.mensajeOverlay = 'Error en el servidor al obtener el lote, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 3000);
          },
        });
      },
      error: (e) => {
        this.loading = false;
        this.mensajeOverlay = 'Error en el servidor al eliminar los registros, inténtelo más tarde';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
      },
    });
  }

  /**
   * Descarga el ticket de báscula asociado a un registro de transporte.
   * @param id - Identificador del registro de transporte cuyo ticket se descarga.
   */
  downloadTicket(id: number) {
    const transport = this.transportList.find( transport => transport.id_cabotage_weight_list === id );
    this.loading = true;
    if (transport) {
      const id_ticket = this.outputForm.get('original_scale')?.value != 3 ? Number(transport.no_ticket) || null : null;
      const id_weight = this.outputForm.get('original_scale')?.value == 3 ? Number(transport.id_cabotage_weight_list) || null : null;
      const genericTicket: GenericTicket = {
        module_id: Module.export,
        operation_type: OperationType.output,
        operation_id: this.id,
        id_ticket: id_ticket,
        id_weight: id_weight,
      };
      this.scaleTicketSvc.downloadGenericScaleTicket(genericTicket)
      .subscribe({
        next: response => {
          this.loading = false;
          if (response.url) {
            window.open(response.url, '_blank');
          } else {
            const message = this.outputForm.get('original_scale')?.value != 3 && !Number(transport.no_ticket) ?
              'Falta el folio del ticket' : 'Error al descargar el archivo, inténtelo más tarde'
            this.mensajeOverlay = message;
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            },3000);
          }
        },
        error: (e) => {
          this.loading = false;
          this.mensajeOverlay = 'Error en el servidor al descargar el archivo, inténtelo más tarde';
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.loading = false;
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          },3000);
        },
      });
    } else {
      this.loading = false;
      this.mensajeOverlay = 'Error al obtener información del transporte, inténtelo más tarde';
      this.iconoOverlay = 'bi bi-exclamation-circle-fill';
      this.loading = false;
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },3000);
    }
  }

  /**
   * Carga un registro de transporte en el formulario para mostrarlo o editarlo según la acción indicada.
   * @param id - Identificador del registro de transporte.
   * @param accion - Acción a realizar sobre el registro (por ejemplo, detalle o edición).
   */
  mostrarSalida(id: number, accion: string) {
    this.updateTranpostForm = true;
    this.ticketChangeCount = 0;
    this.addTransport = false;
    this.currentIdTransport = id;
    this.transportForm.enable();
    this.overlayTransport = true;
    if (this.movimiento !== 'crear') {
      const transport = this.transportList.find( transport => transport.id_cabotage_weight_list === id );
      this.transportForm.reset({
        ...transport
      });
      this.net_weight = transport.net_weight;
      if (accion === 'detalle') {
        this.updateTransport = false;
        this.transportForm.disable();
      } else {
        this.updateTransport = true;
      }
    } else {
      const transport = this.transportList.find( transport => transport.id === id );
      this.transportForm.reset({
        ...transport
      });
      this.net_weight = transport.net_weight;
      if (accion === 'detalle') {
        this.updateTransport = false;
        this.transportForm.disable();
      } else {
        this.updateTransport = true;
      }
    }
  }

  /**
   * Reinicia los campos del formulario de transporte a sus valores vacíos.
   */
  resetTransportForm() {
    this.transportForm.get('gross_weight')?.setValue(null);
    this.transportForm.get('tare_weight')?.setValue(null);
    this.transportForm.get('plate')?.setValue(null);
    this.net_weight = 0;
  }

  /**
   * Calcula y asigna el total de toneladas y piezas a partir de los registros de transporte.
   */
  setTotalTonsPieces() {
    const {totalTons, totalPieces} = this.transportList.reduce( (totals, transport) => {
      totals.totalTons += transport.net_weight;
      totals.totalPieces += transport.quantity_pieces;
      return totals;
    }, {totalTons: 0, totalPieces: 0});
    this.entryTonnage = Number(totalTons) || 0;
    this.entryPieces = Number(totalPieces) || 0;
  }

  // Read QR
  /**
   * Activa o desactiva el modo de lectura de código QR (lector, cámara o cerrar).
   * @param type - Tipo de escáner a utilizar.
   */
  togleReadQR(type: ScannerType) {
    if (this.transportForm.get('no_ticket')?.disabled) {
      return;
    }
    this.overlayScanner = !this.overlayScanner;
    this.scannerEnabled = this.overlayScanner && type === 'camera' ? true : false;
    this.gunScannerEnabled = this.overlayScanner && type === 'scanner' ? true : false;
    this.overlayTransport = this.overlayScanner ? false : true;
  }

  /**
   * Almacena las cámaras encontradas y selecciona la primera disponible para el escáner.
   * @param cameras - Lista de cámaras detectadas en el dispositivo.
   */
  onCamerasFound(cameras: MediaDeviceInfo[]) {
    this.camerasList = [...cameras];
    this.cameraSelected.setValue(this.camerasList[0].deviceId);
    this.selectedDevice = this.camerasList[0];
    this.scannerEnabled = true;
  }

  /**
   * Maneja el caso en que no se encuentran cámaras disponibles para el escáner.
   */
  onCamerasNotFound() {
    this.scannerEnabled = false;
    this.mensajeOverlay = 'No se encontraron cámaras';
    this.iconoOverlay = 'bi bi-info-circle-fill ';
    this.overlay = true;
    setTimeout(() => {
      this.overlay = false;
    }, 2000);
  }

  /**
   * Cambia la cámara activa del escáner según la cámara seleccionada.
   */
  changeCamera() {
    this.selectedDevice = this.getDeviceById(this.cameraSelected.value);
  }

  /**
   * Obtiene una cámara de la lista a partir de su identificador.
   * @param deviceId - Identificador del dispositivo de cámara.
   * @returns La cámara correspondiente o la primera disponible si no se encuentra.
   */
  getDeviceById(deviceId: string): MediaDeviceInfo {
    return this.camerasList.find( camera => camera.deviceId === deviceId) || this.camerasList[0];
  }

  /**
   * Procesa el resultado del escaneo de un código QR con la cámara.
   * @param resultString - Cadena de texto leída del código QR.
   */
  onCodeResult(resultString: string) {
    this.qrResultString = resultString;
    this.isValidQR = true;
    if (this.qrResultString) {
      this.hangleTextQR(this.qrResultString);
    }
    this.togleReadQR(ScannerType.Close);
    this.mensajeOverlay = this.isValidQR ? 'Lectura de boleta de báscula correcta' : 'Error al leer el código QR';
    this.iconoOverlay = this.isValidQR ? 'bi bi-check2' : 'bi bi-exclamation-circle-fill';
    this.overlay = true;
    setTimeout(() => {
      this.qrResultString = '';
      this.scannerTextArea.setValue(null);
      this.overlay = false;
    }, 2000);
  }

  /**
   * Procesa el texto del código QR ingresado manualmente al presionar Enter.
   */
  onEnterPressed() {
    const textQR: string = this.scannerTextArea.value;
    this.isValidQR = true;
    if (textQR && textQR.includes('&')) {
      this.hangleTextQR(textQR);
    } else {
      this.isValidQR = false;
    }
    this.togleReadQR(ScannerType.Close);
    this.mensajeOverlay = this.isValidQR ? 'Lectura de boleta de báscula correcta' : 'Error al leer el código QR';
    this.iconoOverlay = this.isValidQR ? 'bi bi-check2' : 'bi bi-exclamation-circle-fill';
    this.overlay = true;
    setTimeout(() => {
      this.qrResultString = '';
      this.scannerTextArea.setValue(null);
      this.overlay = false;
    }, 2000);
  }

  /**
   * Interpreta la cadena del código QR y asigna sus valores a los campos correspondientes del formulario.
   * @param textQR - Cadena de texto del código QR a interpretar.
   */
  hangleTextQR(textQR: string) {
    const valuesQR: any = textQR.split('&');
    // Logica para leer string y asignarlo a los campos
    if (valuesQR[11] && !isNaN(parseInt(valuesQR[11].charAt(0), 10))) {
      // Boleta del sistema de inventarios nuevo
      this.transportForm.get('gross_weight')?.setValue(valuesQR[11].replace(',', '') > 0 ? Number(valuesQR[11].replace(',', '')) / 1000 : 0);
      this.transportForm.get('tare_weight')?.setValue(valuesQR[12].replace(',', '') > 0 ? Number(valuesQR[12].replace(',', '')) / 1000 : 0);
      this.net_weight = valuesQR[13].replace(',', '') > 0 ? Number(valuesQR[13].replace(',', '')) / 1000 : 0;
      this.transportForm.get('plate')?.setValue(valuesQR[8]);
      this.transportForm.get('no_ticket')?.setValue(valuesQR[0]);
    } else if (valuesQR[12] && !isNaN(parseInt(valuesQR[12].charAt(0), 10))) {
      // Boleta del sistema de inventarios viejo
      this.transportForm.get('gross_weight')?.setValue(valuesQR[12].replace(',', '') > 0 ? Number(valuesQR[12].replace(',', '')) / 1000 : 0);
      this.transportForm.get('tare_weight')?.setValue(valuesQR[13].replace(',', '') > 0 ? Number(valuesQR[13].replace(',', '')) / 1000 : 0);
      this.net_weight = valuesQR[14].replace(',', '') > 0 ? Number(valuesQR[14].replace(',', '')) / 1000 : 0;
      this.transportForm.get('plate')?.setValue(valuesQR[7]);
      this.transportForm.get('no_ticket')?.setValue(valuesQR[0]);
    } else {
      this.isValidQR = false;
    }
  }

  /**
   * Calcula y actualiza los totales de peso neto y piezas a partir de la lista de transportes.
   * @param transportList - Lista de registros de transporte sobre la que se calculan los totales.
   */
  updateTotals(transportList: Transport[]) {
    this.table_config.totals!.totalNetWeight = transportList.reduce( (previous, current) => previous + Number(current.net_weight), 0);
    this.table_config.totals!.piezas = transportList.reduce( (previous, current) => previous + Number(current.quantity_pieces), 0);
  }

  /**
   * Obtiene el nombre de la embarcación a partir de su número.
   * @param shipNumber - Número de la embarcación a buscar.
   * @returns El nombre de la embarcación o una cadena vacía si no se encuentra.
   */
  getShipNameByNumber(shipNumber: number): string {
    const boat = this.boats.find( boat => boat.boats_number == shipNumber);
    return boat ? boat.boats_name : '';
  }
}
